// extracted by mini-css-extract-plugin
module.exports = {"appBarStyled":"AppBarNotAuth_appBarStyled__3O7_g"};